import { render } from "./MyJumpListView.vue?vue&type=template&id=35434f26"
import script from "./MyJumpListView.vue?vue&type=script&lang=js"
export * from "./MyJumpListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__